// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.debugWindow {
    position: absolute;
    width: 600px;
    height: 400px;
    resize: both;
    z-index: 10;
    border: 1px solid lightgray;
    border-radius: 5px;
    background: white;
    overflow: auto;
}

    .debugWindow.hidden {
        display: none;
        z-index: -1;
    }

    .debugWindow.fullscreen {
        width: 100%!important;
        height: 100%!important;
        transform: initial!important;
        resize: none;
    }`, "",{"version":3,"sources":["webpack://./src/app/debugconsole/debug.window.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,YAAY;IACZ,aAAa;IACb,YAAY;IACZ,WAAW;IACX,2BAA2B;IAC3B,kBAAkB;IAClB,iBAAiB;IACjB,cAAc;AAClB;;IAEI;QACI,aAAa;QACb,WAAW;IACf;;IAEA;QACI,qBAAqB;QACrB,sBAAsB;QACtB,4BAA4B;QAC5B,YAAY;IAChB","sourcesContent":[".debugWindow {\n    position: absolute;\n    width: 600px;\n    height: 400px;\n    resize: both;\n    z-index: 10;\n    border: 1px solid lightgray;\n    border-radius: 5px;\n    background: white;\n    overflow: auto;\n}\n\n    .debugWindow.hidden {\n        display: none;\n        z-index: -1;\n    }\n\n    .debugWindow.fullscreen {\n        width: 100%!important;\n        height: 100%!important;\n        transform: initial!important;\n        resize: none;\n    }"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
